import { SlickError } from 'errors/Slick.error';
import logger from 'utils/logger.util';

const L = logger('ERRORS'); // eslint-disable-line no-unused-vars

const isDomError = (value) => {
  try {
    if (null === value) return false;
    if (void 1 === value) return false;

    return value instanceof DOMException;
  } catch (e) {
    L.error('isDomError()', value, '->', e);
  }

  return false;
};

export const isAnyError = (value) => {
  if (null === value) return false;
  if (void 1 === value) return false;

  try {
    if (Error.isError) return Error.isError(value);
  } catch (e) {
    L.error('isAnyError()', value, '->', e);
  }

  try {
    return value instanceof Error || isDomError(value);
  } catch (e) {
    L.error('isAnyError()', value, '->', e);
  }

  return false;
};

export const isSlickError = (value) => {
  try {
    return value instanceof SlickError;
  } catch (e) {
    L.error('isSlickError()', value, '->', e);
  }
  return false;
};

export const isTimeOutError = (value) => isDomError(value) && 'TimeoutError' === value?.name;
